import { reactive, readonly, DeepReadonly } from "vue";

interface StoreState {
  username: string;
  role: string;
  isLoggedIn: boolean;
}

// Make the state object reactive
const state = reactive<StoreState>({
  username: "NULL",
  role: "NULL",
  isLoggedIn: false,
});

// Export the state object as read-only to prevent accidental modifications
export const store: DeepReadonly<StoreState> = readonly(state);

export function logIn(login_response: {
  username: string;
  role: string;
}): void {
  state.username = login_response.username;
  state.role = login_response.role;
  state.isLoggedIn = true;
}

export function logoutSession(): void {
  state.username = "NULL";
  state.isLoggedIn = false;
}
